import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API, BUSINESS } from "@/lib/api";
import { imgUrl } from "@/components/site/WorkGallery";
import { ShareButtons } from "@/components/site/ShareButtons";

export default function WorkItem() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  useEffect(() => {
    axios.get(`${API}/gallery/${id}`).then((r) => setItem(r.data)).catch(() => setItem(false));
  }, [id]);
  return (
    <div className="min-h-screen bg-[#0E1F3F] px-4 py-10 text-white" data-testid="work-item-page">
      <div className="mx-auto max-w-4xl">
        <Link to="/" className="inline-block" data-testid="work-home-link"><img src="/brand/logo.png" alt="Firm Foundations" className="h-16 w-auto" /></Link>
        {item === false && <p className="mt-10" data-testid="work-not-found">This photo is no longer available.</p>}
        {item && (
          <>
            <img src={imgUrl(item.id)} alt={item.title} className="mt-8 max-h-[75vh] w-full rounded-xl object-contain" />
            <div className="mt-5 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
              <div><h1 className="font-display text-2xl font-bold">{item.title}</h1>{item.caption && <p className="text-white/70">{item.caption}</p>}</div>
              <ShareButtons item={item} dark />
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/#estimate" className="rounded-full bg-[#F2B91C] px-6 py-3 text-sm font-bold text-[#0E1F3F]" data-testid="work-estimate-btn">Get a free estimate</Link>
              <a href={BUSINESS.phoneHref} className="rounded-full border border-white/40 px-6 py-3 text-sm font-semibold">Call {BUSINESS.phone}</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
